<template>
  <div id="clock">
    <label class="time">{{ title }}: </label>
    <span class="time">{{ formattedTime }}</span>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "Timer",
  props: {
    title: {
      type: String,
      required: true
    },
    endingTime: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      timeRemaining: 0,
      timerInterval: null
    };
  },
  computed: {
    formattedTime() {
      if (this.timeRemaining <= 0) return "00:00:00";

      const seconds = Math.floor(this.timeRemaining / 1000);
      const minutes = Math.floor(seconds / 60);
      const hours = Math.floor(minutes / 60);
      const days = Math.floor(hours / 24);

      if (days > 0) return `${days} day${days > 1 ? "s" : ""} left`;
      if (hours > 0) return `${hours} hour${hours > 1 ? "s" : ""} left`;
      if (minutes > 0) return `${minutes} minute${minutes > 1 ? "s" : ""} left`;
      return `${seconds} second${seconds > 1 ? "s" : ""} left`;
    }
  },
  methods: {
    updateTime() {
      const now = moment();
      const targetTime = moment(this.endingTime);
      this.timeRemaining = Math.max(0, targetTime.diff(now)); // Get difference in milliseconds

      if (this.timeRemaining <= 0) {
        clearInterval(this.timerInterval);
      }
    }
  },
  mounted() {
    this.updateTime();
    this.timerInterval = setInterval(this.updateTime, 1000);
  },
  beforeUnmount() {
    clearInterval(this.timerInterval);
  }
};
</script>

<style scoped>
#clock {
  text-align: center;
  margin-top: 20px;
}
.time {
  font-size: 1.5em;
  font-weight: bold;
}
</style>
